import { GetRecordHeaderWithChildren } from 'ui-component/records/types';
import { HierarchyBreadcrumbLevel } from './components';
import { capitalize } from 'utils/stringHelpers';

export const generateBreadcrumbLevels = (
    parentRecord?: GetRecordHeaderWithChildren,
    initialRecordId?: string
): HierarchyBreadcrumbLevel[] => {
    const breadcrumbLevels: HierarchyBreadcrumbLevel[] = [];

    if (!parentRecord) return breadcrumbLevels;

    // Recursive function to process hierarchy up to initialRecordId
    const processHierarchy = (record: GetRecordHeaderWithChildren, level: number = 0) => {
        // Add current level to breadcrumb
        breadcrumbLevels.push({
            id: record.id,
            name: `${capitalize(record.recordType.name)}-${record.id}`,
            recordTypeId: +record.recordType.id,
            recordTypeName: record.recordType.name,
            level: record.level
        });

        // If this is the initialRecord, stop here
        if (initialRecordId && record.id === initialRecordId) {
            return;
        }

        // If there are children, process the first child (assuming we want to show the deepest path)
        if (record.children && record.children.length > 0) {
            const firstChild = record.children[0];
            processHierarchy(firstChild, level + 1);
        }
    };

    // Start with the parent record
    processHierarchy(parentRecord);

    return breadcrumbLevels;
};
